const ROLES = {
  STAFF: 'staff',
  MANAGER: 'manager',
  OWNER: 'owner',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
};
export default ROLES;
